import { render } from "./ChatBotSettings.vue?vue&type=template&id=2bd8628a"
import script from "./ChatBotSettings.vue?vue&type=script&lang=js"
export * from "./ChatBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__